<div class="about-dialog">
  <div class="about-header">
    <img src="assets/images/jkaw-icon/android-chrome-192x192.png" alt="Infokaw" class="about-logo">
    <div>
      <h2 mat-dialog-title class="about-title">{{ info.appName }}</h2>
      <span class="about-subtitle">Gestão Empresarial</span>
    </div>
    <span class="env-badge" [ngClass]="'env-' + info.environmentName" *ngIf="info.environmentName !== 'prod'">
      {{ info.environmentName | uppercase }}
    </span>
  </div>

  <mat-dialog-content>
    <table class="about-table">
      <tr>
        <td class="k">Versão</td>
        <td class="v">{{ info.version }}</td>
      </tr>
      <tr>
        <td class="k">Commit</td>
        <td class="v mono">{{ info.commit }}</td>
      </tr>
      <tr>
        <td class="k">Branch</td>
        <td class="v mono">{{ info.branch }}</td>
      </tr>
      <tr>
        <td class="k">Build</td>
        <td class="v">{{ info.buildDate | date: 'dd/MM/yyyy HH:mm' }}</td>
      </tr>
      <tr>
        <td class="k">Ambiente</td>
        <td class="v">{{ info.environmentName | uppercase }}</td>
      </tr>
      <tr>
        <td class="k">API</td>
        <td class="v mono">{{ info.apiURL }}</td>
      </tr>
      <tr>
        <td class="k">Build backend</td>
        <td class="v">
          <span *ngIf="loadingBackend">carregando…</span>
          <span *ngIf="!loadingBackend">{{ backendBuild || 'indisponível' }}</span>
        </td>
      </tr>
    </table>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="copyright">Infokaw Software — Soluções em Software</span>
    <span class="spacer"></span>
    <button mat-button mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
